/** The four starters of an entity-scoped Ask, in order (CT-5721). */
const ASK_STARTER_KEYS = Object.freeze(['prepCall', 'callScript', 'whatChanged', 'whatWeOwe']);

/**
 * The copy an Ask hands to the shell's Concierge (CT-5721): the intro, the input
 * placeholder and the four starters, all this app's, translated with `t`. The
 * host only renders them.
 *
 * `request.entity.title` is the name the caller already resolved (the same one
 * the header shows, "Untitled" included); this function adds no fallback.
 *
 * @param {{ entity?: { title?: string } }} request — an `intent: 'ask'` request.
 * @param {(key: string, values?: object) => string} t
 * @returns {object} a new request; the given one is not changed.
 */
export const buildAskPayload = (request, t) => {
  const name = request.entity?.title;
  return {
    ...request,
    intro: t('profile.ask.intro', { name }),
    placeholder: t('profile.ask.placeholder', { name }),
    starters: ASK_STARTER_KEYS.map((key) => t(`profile.ask.starters.${key}`)),
  };
};
